<!--
  Layout B, split view: the library stays on the left and whatever is open (a set, a note's
  attachments, compare, Edit set, capture) fills the panel on the right, so the place in the list
  is never lost. On a phone there is room for one side only, and it behaves like the pages layout.
-->
<template>
  <div class="md-split" :class="{ 'is-open': nav.view !== 'library' }">
    <div class="md-split-list">
      <MediaLibrary compact :active-key="nav.activeKey" v-on="nav.on.library" />
    </div>
    <div class="md-split-panel">
      <div v-if="nav.view === 'library'" class="md-split-empty">
        <strong>Nothing open</strong>
        <span>Pick a set, a progression, an item or a note on the left to open it here.</span>
      </div>
      <MediaSetView v-else-if="nav.isViewer" layout="panel" :context="nav.viewerContext" :back-label="viewerBack" v-on="nav.on.viewer" />
      <MediaCompare v-else-if="nav.view === 'compare'" layout="panel" :ids="nav.pair" :back-label="nav.backLabel" v-on="nav.on.compare" />
      <MediaSetEditor v-else-if="nav.view === 'edit' && nav.setId" layout="panel" :set-id="nav.setId" :back-label="nav.backLabel" v-on="nav.on.editor" />
      <MediaCaptureFlow v-else-if="nav.view === 'capture'" layout="panel" :as-note="nav.asNote" :patient-uid="store.patientUid" :back-label="narrow ? 'Back to Media' : 'Close'" v-on="nav.on.capture" />
    </div>
  </div>
</template>

<script setup>
import { ref, computed, onMounted, onBeforeUnmount } from 'vue';
import { useMediaStore } from '@/stores/mediaStore';
import MediaLibrary from './MediaLibrary.vue';
import MediaSetView from './MediaSetView.vue';
import MediaCompare from './MediaCompare.vue';
import MediaSetEditor from './MediaSetEditor.vue';
import MediaCaptureFlow from './MediaCaptureFlow.vue';

const props = defineProps({ nav: { type: Object, required: true } });
const store = useMediaStore();

// Beside the list, the viewer closes rather than going "back" to a library that is already showing.
const query = window.matchMedia ? window.matchMedia('(max-width: 900px)') : null;
const narrow = ref(!!(query && query.matches));
const onChange = (e) => { narrow.value = e.matches; };
const viewerBack = computed(() => (narrow.value || props.nav.backLabel !== 'Back to Media' ? props.nav.backLabel : 'Close'));
onMounted(() => query && query.addEventListener && query.addEventListener('change', onChange));
onBeforeUnmount(() => query && query.removeEventListener && query.removeEventListener('change', onChange));
</script>

<style scoped>
.md-split { display:grid; grid-template-columns:minmax(300px, 400px) minmax(0, 1fr); gap:18px; align-items:start; }
.md-split-list { position:sticky; top:12px; max-height:calc(100vh - 24px); overflow:auto; padding-right:4px; }
.md-split-panel { min-width:0; background:#fff; border:1px solid var(--line); border-radius:12px; padding:16px; min-height:420px; }
.md-split-empty { height:380px; display:flex; flex-direction:column; align-items:center; justify-content:center; gap:6px; color:var(--muted); text-align:center; }
.md-split-empty strong { color:var(--ink); font-size:17px; }
@media (max-width: 900px) {
  .md-split { grid-template-columns:1fr; }
  .md-split-list { position:static; max-height:none; overflow:visible; }
  .md-split-panel { display:none; padding:0; border:none; min-height:0; }
  .md-split.is-open .md-split-list { display:none; }
  .md-split.is-open .md-split-panel { display:block; }
}
</style>
